import React, { useState, useContext } from 'react';
import { Button, CircularProgress, MenuItem } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import styles from './QAPhotoDownloadMenuItem.styles';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import cn from 'classnames';

// SERVICES
import { AppContext } from '../../../../../AppContext';
import { OrderReviewContext } from '../../../OrderReviewContext';
import { getZippedImages } from '../../../../../services';

const QAPhotoDownloadMenuItem = ({ classes, onClose }) => {
  const [isDownloadingImages, setIsDownloadingImages] = useState(false);

  const { dispatch: appDispatch } = useContext(AppContext);
  const {
    state: { orderLineId },
  } = useContext(OrderReviewContext);

  const downloadImages = async () => {
    try {
      setIsDownloadingImages(true);
      await getZippedImages(orderLineId);
      appDispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'success',
          message: 'Pictures zipped',
        },
      });
    } catch (error) {
      appDispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'error',
          message: 'Download failed... Please try again',
        },
      });
    }
    setIsDownloadingImages(false);

    !!onClose && onClose();
  };

  return (
    <React.Fragment>
      <MenuItem disabled={isDownloadingImages} onClick={downloadImages}>
        <span className={cn('mr-10')}>{isDownloadingImages ? 'Downloading' : 'Download Photos'}</span>
        <span>
          {isDownloadingImages ? (
            <CircularProgress style={{ color: 'black' }} size={14} />
          ) : (
            <CloudDownloadIcon style={{ fontSize: 14, display: 'flex' }} />
          )}
        </span>
      </MenuItem>
    </React.Fragment>
  );
};

QAPhotoDownloadMenuItem.defaultProps = {};
QAPhotoDownloadMenuItem.propTypes = {};

export default withStyles(styles)(QAPhotoDownloadMenuItem);
